import React from 'react';
import { FormattedMessage } from 'react-intl';
import AdminRoutePlanV2RouteSetupPickupSlotDisplay from './adminRoutePlanV2RouteSetupPickupSlotDisplay';
import utils from '../../utils/utils';

const AdminRoutePlanV2RouteSetupDisplay = ({ routePlanSetup }) => {
  return (
    <div className="form-block">
      <div className="m-b-1">
        <strong>
          <FormattedMessage id={'admin.route.plan.setups.setup.field.delivery.day.time.ranges'} />
        </strong>
        :
      </div>
      <div className="m-b-3">
        {routePlanSetup.deliveryDayTimeRanges.map((ddtr) => {
          return (
            <div className="m-b-2">
              {utils.getFormattedTimeRange(ddtr)} {ddtr.serviceAreaName}
            </div>
          );
        })}
      </div>
      <div className="m-b-2">
        <strong>
          <FormattedMessage id={'admin.route.plan.setups.setup.pickup.slots'} />
        </strong>
        :{' '}
      </div>
      {routePlanSetup.pickupSlots.map((pickupSlot) => (
        <div className="form-block m-darker m-b-2">
          <AdminRoutePlanV2RouteSetupPickupSlotDisplay pickupSlot={pickupSlot} />
        </div>
      ))}
    </div>
  );
};

export default AdminRoutePlanV2RouteSetupDisplay;
